export default class AppcuesService {
  get isAvailable() {
    return typeof window !== "undefined" && window.Appcues;
  }

  identify(userId, properties = {}) {
    const payload =
      Object.keys(properties).length > 0 ? [userId, properties] : [userId];
    window.Appcues?.identify(...payload);
  }

  group(organizationCode) {
    window.Appcues?.group(organizationCode);
  }

  track(eventName, properties = {}) {
    window.Appcues?.track(eventName, properties);
  }

  reset() {
    window.Appcues?.group();
    window.Appcues?.reset();
  }
}
